import { css } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Link, Typography2 } from '@coursera/cds-core';

import { useDegreeMetadataContext } from 'bundles/degree-home/components/v3-dpm/context/DegreeMetadataContext';

import _t from 'i18n!nls/degree-home';

const WhereToGoFromHereDialog: React.VFC = () => {
  const { degreeMetadata } = useDegreeMetadataContext();
  const supportLink = degreeMetadata?.supportLink;
  const supportEmailAddress = degreeMetadata?.supportEmailAddress || '';

  const contactSupportText = supportLink ? (
    <Link href={supportLink} target="_blank" rel="noopener noreferrer">
      {_t('Contact program support team')}
    </Link>
  ) : (
    <FormattedMessage
      message={_t('Email {supportEmailAddress} to contact the program support team')}
      supportEmailAddress={<Link href={`mailto:${supportEmailAddress}`}>{supportEmailAddress}</Link>}
    />
  );

  return (
    <React.Fragment>
      <Typography2 component="p">
        {_t(
          "Contact your program support team to learn about your university's repeat and program policies. They will guide you on the necessary next steps to keep progressing towards graduation."
        )}
      </Typography2>
      <Typography2
        component="p"
        css={(theme) => css`
          margin-top: ${theme.spacing(12)};
        `}
      >
        {contactSupportText}
      </Typography2>
    </React.Fragment>
  );
};

export default WhereToGoFromHereDialog;
